import { donationDelete, donationsByUserId } from '@/entities/donations'
import { type GetApiDonationsByUserIdPathParams } from '@/shared/api'
import { createEvent, sample } from 'effector'
import { createGate } from 'effector-react'

interface DonationsByUserGateProps {
  id: GetApiDonationsByUserIdPathParams['Id']
}
export const DonationsByUserGate = createGate<DonationsByUserGateProps>()
const donationsByUserIdTableRefreshed = createEvent()

sample({
  source: DonationsByUserGate.state,
  clock: [DonationsByUserGate.open, donationsByUserIdTableRefreshed],
  filter: (params): params is DonationsByUserGateProps =>
    Boolean(params) && Boolean(params.id),
  target: donationsByUserId.start,
})

sample({
  clock: DonationsByUserGate.close,
})

sample({
  clock: donationDelete.finished.success,
  target: donationsByUserIdTableRefreshed,
})
